export const LOGOUT_USER_START = 'LOGOUT_USER_START';
export const LOGOUT_USER_END = 'LOGOUT_USER_END';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const LOGOUT_USER_FAILURE = 'LOGOUT_USER_FAILURE';
